import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ar from './locales/ar.json';
import en from './locales/en.json';

const LANGUAGE_STORAGE_KEY = 'wheels.backoffice.language';

export type SupportedLanguage = 'ar' | 'en';

function readStoredLanguage(): SupportedLanguage {
  const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
  return stored === 'en' ? 'en' : 'ar';
}

export async function initI18n(): Promise<void> {
  await i18n.use(initReactI18next).init({
    resources: {
      ar: { translation: ar },
      en: { translation: en },
    },
    lng: readStoredLanguage(),
    fallbackLng: 'ar',
    interpolation: { escapeValue: false },
    returnNull: false,
  });

  applyDocumentDirection(i18n.language as SupportedLanguage);
  i18n.on('languageChanged', (lng) => {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
    applyDocumentDirection(lng as SupportedLanguage);
  });
}

export function applyDocumentDirection(language: SupportedLanguage): void {
  document.documentElement.lang = language;
  document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
}
